import React from "react";
import ButtonIcon from "./ButtonIcon.jsx";

export default function ButtonIconCancel(props) {
    // Combine component className
    const className = ["button-cancel-base"];
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);

    return (
        <ButtonIcon
            {...props}
            icon={
                // /public/img/icon-cancel.svg
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="black">
                    <rect
                        x="46"
                        y="394.986"
                        width="493.541"
                        height="100.503"
                        rx="50.2514"
                        transform="rotate(-45 46 394.986)"
                    />

                    <rect
                        x="117.066"
                        y="46"
                        width="493.541"
                        height="100.503"
                        rx="50.2514"
                        transform="rotate(45 117.066 46)"
                    />
                </svg>
            }
        />
    );
}
